export default "__VITE_ASSET__$Z06kY_t__"